// extracted by mini-css-extract-plugin
export default {"roundedButton":"PackageDetailsTable_roundedButton__o3LQI","tableContainer":"PackageDetailsTable_tableContainer__So9BN"};